import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UntypedFormControl} from '@angular/forms';
import {CommonService} from '@services/common.service';
import {AdService} from '@services/ad.service';
import {MatDialog} from '@angular/material/dialog';
import {BuyCongratsComponent} from '../buy-congrats/buy-congrats.component';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

    @Input() favorite: Favorite;
    panelColor = new UntypedFormControl('');
    private previousStatus = '';

    constructor(
        private adService: AdService,
        public commonService: CommonService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.panelColor.setValue(this.favorite.status);
        this.previousStatus = this.favorite.status;
    }

    edit(event, fields = '') {
        const becomesOwner = this.favorite.status === 'buy' && this.previousStatus !== 'buy';
        const previous = this.previousStatus;
        this.previousStatus = this.favorite.status;
        this.adService.updateFavoriteStatus(this.favorite).subscribe(result => {
            // Le popup n'a de sens que si le statut a bien été enregistré
            if (becomesOwner) {
                this.dialog.open(BuyCongratsComponent, {
                    width: '480px',
                    maxWidth: '92%',
                    data: {},
                });
            }
        }, error => {
            // Échec serveur : revenir au statut réel, sinon l'affichage ment
            // et un re-clic sur « Propriétaire » ne re-tenterait jamais l'enregistrement
            this.favorite.status = previous;
            this.previousStatus = previous;
            this.panelColor.setValue(previous);
        });
    }
}
